export default __webpack_public_path__ + "static/media/pm-10.b941947f.svg";